// Voucher Types and Enums

export enum VoucherType {
  // Receive Vouchers
  CRV = 'CRV', // Cash Receive Voucher
  BRV = 'BRV', // Bank Receive Voucher
  SDV_RECEIVE = 'SDV_RECEIVE', // Security Deposit Receive
  INTEREST_RECEIVE = 'INTEREST_RECEIVE',
  DIVIDEND_RECEIVE = 'DIVIDEND_RECEIVE',

  // Payment Vouchers
  CPV = 'CPV', // Cash Payment Voucher
  BPV = 'BPV', // Bank Payment Voucher
  ADV = 'ADV', // Advance Payment Voucher
  BDV = 'BDV', // Bank Deposit Voucher
  SDV_REFUND = 'SDV_REFUND', // Security Deposit Refund
  INV = 'INV', // Investment/Issue Voucher

  // Other Vouchers
  AIT_VAT = 'AIT_VAT',
  JOURNAL = 'JOURNAL',
  COLLECTION_JOURNAL = 'COLLECTION_JOURNAL',
  INSTALLMENT = 'INSTALLMENT',
  ADJUSTMENT_JOURNAL = 'ADJUSTMENT_JOURNAL',
  CONTRA = 'CONTRA',
  FOUT = 'FOUT', // Fund Out
  FIN = 'FIN', // Fund In
}

export enum TransactionMode {
  CASH = 'Cash',
  CHEQUE = 'Cheque',
  DEPOSIT = 'Deposit',
  BEFTN = 'BEFTN',
  RTGS = 'RTGS',
  ONLINE_TRANSFER = 'Online Transfer',
  MOBILE_BANKING = 'Mobile Banking',
}

export enum VoucherStatus {
  DRAFT = 'Draft',
  PENDING = 'Pending',
  COMPLETED = 'Completed',
  APPROVED = 'Approved',
  AUDITED = 'Audited',
  POSTED = 'Posted',
  REJECTED = 'Rejected',
  CANCELLED = 'Cancelled',
}

export enum ApprovalLevel {
  LEVEL_1 = 'Level 1',
  LEVEL_2 = 'Level 2',
  LEVEL_3 = 'Level 3',
}

export interface VoucherLine {
  id?: string
  accountId: string
  accountCode?: string
  accountName?: string
  debit: number
  credit: number
  description?: string
  branchId?: string
  projectId?: string
  costCenterId?: string
}

export interface ChequeDetails {
  chequeNo: string
  issueDate: string
  bankName: string
  bankBranch?: string
  accountNumber: string
  validityDate?: string
}

export interface Voucher {
  id: string
  voucherNo: string
  voucherType: VoucherType
  date: string
  transactionMode: TransactionMode
  referenceNo?: string
  partyId?: string
  partyName?: string
  partyType?: 'Customer' | 'Vendor' | 'Employee' | 'Other'

  // Financial
  totalDebit: number
  totalCredit: number
  amount: number

  // Organizational
  branchId?: string
  branchName?: string
  projectId?: string
  projectName?: string
  costCenterId?: string
  costCenterName?: string

  // Cheque Details
  chequeDetails?: ChequeDetails

  // Lines
  lines: VoucherLine[]

  // Description & Attachments
  description?: string
  narration?: string
  attachments?: string[]

  // Status & Workflow
  status: VoucherStatus
  isEditable: boolean
  isLocked: boolean
  fiscalYear: string

  // References
  billId?: string
  billNo?: string
  workOrderId?: string
  workOrderNo?: string
  relatedVoucherId?: string

  // Approval History
  approvalHistory: ApprovalRecord[]

  // Audit Trail
  createdBy: string
  createdAt: string
  completedBy?: string
  completedAt?: string
  approvedBy?: string
  approvedAt?: string
  auditedBy?: string
  auditedAt?: string
  postedBy?: string
  postedAt?: string
  updatedBy?: string
  updatedAt?: string
}

export interface ApprovalRecord {
  id: string
  level: ApprovalLevel
  status: 'Pending' | 'Approved' | 'Rejected'
  approvedBy?: string
  approvedAt?: string
  comments?: string
}

export interface VoucherFormData {
  voucherType: VoucherType
  date: string
  transactionMode: TransactionMode
  referenceNo?: string
  partyId?: string
  branchId?: string
  projectId?: string
  costCenterId?: string
  chequeDetails?: ChequeDetails
  lines: VoucherLine[]
  description?: string
  narration?: string
  attachments?: File[]
  billId?: string
  workOrderId?: string
}

export interface VoucherFilters {
  voucherNo?: string
  voucherType?: VoucherType
  transactionMode?: TransactionMode
  status?: VoucherStatus
  branchId?: string
  projectId?: string
  partyId?: string
  dateFrom?: string
  dateTo?: string
  createdBy?: string
  approvedBy?: string
  minAmount?: number
  maxAmount?: number
}

export interface VoucherNumberConfig {
  prefix: string
  bankPrefix?: string
  branchCode: string
  fiscalYear: string
  nextSerial: number
}
